import React from "react";
import { Box, Button, Paper, Slide, Typography } from "@mui/material";

export default function XplorOnboarding(props) {
  return (
    <Slide direction="up" in={props.step === 2} mountOnEnter unmountOnExit>
      <Box>
        <Paper elevation={0}>
          <Box px={3} py={3}>
            <Box mb={2}>
              <Typography variant="h5" gutterBottom>
                Final Step: Setup your Payments
              </Typography>
              <Typography variant="body1" color="textSecondary">
                You’re one step away from accepting payments. This secure application takes about
                5–10 minutes. Please have your EIN & bank account details ready.
              </Typography>
            </Box>
          </Box>
        </Paper>
        <Box my={2}>
          <Button
            component="a"
            href={props.data.xplor.applicationUrl}
            variant="contained"
            color="primary"
            size="large"
            fullWidth
          >
            Setup Payments
          </Button>
        </Box>
      </Box>
    </Slide>
  );
}
